import React from "react"
import { Outlet } from "react-router-dom"

import Navbar from "../../components/Navbar"
import ProfileAvatar from "../../components/ProfileAvatar"
import withProtectedRoute from "../../routes/ProtectedRoute"

const Dashboard = () => {

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Main Content */}
      <main className="flex max-md:flex-col items-start gap-4 max-w-7xl mx-auto px-4 py-8">

        {/* Profile Section */}
        <div className="max-lg:hidden w-96">
          <ProfileAvatar />
        </div>

        {/* Home Page */}
        <Outlet />

        {/* Section Three */}
        <section className="space-y-4 w-96">
          <div className="w-full h-32 rounded-xl bg-background" />
          <div className="w-full h-32 rounded-xl bg-background" />
        </section>
      </main>
    </div >
  )
}

export default withProtectedRoute(Dashboard)
